import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_TENANT } from '@src/util/query/tenant.query';

// messaging/calling are opt-in per tenant (enforced server-side too — see
// wfc-server tenant.service.ts, calling can never be true without messaging).
// Was duplicated between messagingDrawer.jsx and navbar/index.jsx; anything
// that needs to gate a call/chat entry point (e.g. the employee-detail
// sidebar icons) should pull from here instead of re-querying GET_TENANT.
//
// Licensed modules are switched per tenant by WFC360 too. Scheduling, mobile response
// and key management were always part of the product, so anything not explicitly
// switched off (`!== false`) counts as on - including while the tenant is still
// loading, so existing tenants never see those menus flicker away. Annual leave (holiday)
// works the same way - leave recording was always there. Compliance, appraisals and
// surveys are new opt-in modules: only an explicit `true` turns them on. Uniform and Payroll too.
export function useTenantFeatureFlags() {
    const { authenticatedUserDetail } = useSelector(s => s.userAuthReducer);
    const tenantId = authenticatedUserDetail?.tenantId || localStorage.getItem('tenantId');

    const { data: tenantData, loading } = useQuery(GET_TENANT, {
        variables: { tenantId },
        skip: !tenantId,
        fetchPolicy: 'cache-first',
    });

    const tenant = tenantData?.getTenant?.response;

    const messagingEnabled = tenant?.messaging === true;
    const callingEnabled = messagingEnabled && tenant?.calling === true;

    const schedulingEnabled = tenant?.scheduling !== false;
    const mobileResponseEnabled = tenant?.mobileResponse !== false;
    const keyManagementEnabled = tenant?.keyManagement !== false;
    const holidayEnabled = tenant?.holiday !== false;
    const complianceEnabled = tenant?.compliance === true;
    const appraisalsEnabled = tenant?.appraisals === true;
    const surveysEnabled = tenant?.surveys === true;
    const uniformEnabled = tenant?.uniform === true;
    const payrollEnabled = tenant?.payroll === true;

    return {
        messagingEnabled,
        callingEnabled,
        schedulingEnabled,
        mobileResponseEnabled,
        keyManagementEnabled,
        holidayEnabled,
        complianceEnabled,
        appraisalsEnabled,
        surveysEnabled,
        uniformEnabled,
        payrollEnabled,
        loading,
        tenantId,
    };
}
